import * as moment from 'moment';
import { Level, Log } from 'ng2-logger/browser';

export class LogInfo {

    constructor(log: Log, isDefault: boolean = false) {
        this.l = log;
        this.isDef = isDefault;
    }

    private l: Log;
    public get log(): Log { return this.l; }

    private isDef = false;
    public get isDefault(): boolean { return this.isDef; }

    public error(message: string, ...params: any[]): void { (this.log as any).er(moment(new Date()).format('HH:mm:ss.SSS'), [message, ...params]); }
    public info(message: string, ...params: any[]): void { (this.log as any).i(moment(new Date()).format('HH:mm:ss.SSS'), [message, ...params]); }
    public warn(message: string, ...params: any[]): void { (this.log as any).w(moment(new Date()).format('HH:mm:ss.SSS'), [message, ...params]); }
    public debug(message: string, ...params: any[]): void { (this.log as any).d(moment(new Date()).format('HH:mm:ss.SSS'), [message, ...params]); }
}

export interface ILogIndexer {
    [name: string]: LogInfo;
}

export class Logger {

    public static get DEFAULT_LOG_NAME(): string { return 'bootstrap'; }

    public static sinks: ILogIndexer = { };

    private static defaultSink: LogInfo = new LogInfo(Log.create(Logger.DEFAULT_LOG_NAME, Level.ERROR, Level.INFO, Level.WARN, Level.DATA));

    public static addLog(name: string, log: Log, isDefault: boolean = false) {
        Logger.sinks[name] = new LogInfo(log, isDefault);

        if (isDefault) {
            Logger.defaultSink = Logger.sinks[name];
        }
    }

    public static error(message: string, ...params: any[]): void { (Logger.defaultSink.log as any).er(moment(new Date()).format('HH:mm:ss.SSS'), [message, ...params]); }
    public static info(message: string, ...params: any[]): void { (Logger.defaultSink.log as any).i(moment(new Date()).format('HH:mm:ss.SSS'), [message, ...params]); }
    public static warn(message: string, ...params: any[]): void { (Logger.defaultSink.log as any).w(moment(new Date()).format('HH:mm:ss.SSS'), [message, ...params]); }
    public static debug(message: string, ...params: any[]): void { (Logger.defaultSink.log as any).d(moment(new Date()).format('HH:mm:ss.SSS'), [message, ...params]); }
}
